import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../../components/HeaderDashboard';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';

import { Box, Typography } from "@mui/material";
import { useUser } from '../../../contexts/UserContext';
import { MascaraCpf } from '../../../utils/MascaraCpf';
import { MascaraCnpj } from '../../../utils/MascaraCnpj';
import axios from 'axios';
import { TirarMascara } from '../../../utils/TirarMascara';
import FormLabel from '@mui/material/FormLabel';

import Loading from '../../components/Loading';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { ptBR } from "date-fns/locale";

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { MascaraCep } from '../../../utils/MascaraCep';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Card } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import AlertError from '../../components/AlertError';

import AlertSuccess from '../../components/AlertSuccess';
import { NumericFormat } from 'react-number-format';


const EmitirNotaServico = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [hasTomador, setHasTomador] = useState(false);
    const [servicos, setServicos] = useState([]);

    const [cpfCnpjTomador, setCpfCnpjTomador] = useState('');
    const [emailTomador, setEmailTomador] = useState('');
    const [cepTomador, setCepTomador] = useState('');
    const [enderecoTomador, setEnderecoTomador] = useState('');
    const [numeroTomador, setNumeroTomador] = useState('');
    const [estadoTomador, setEstadoTomador] = useState('');
    const [cidadeTomador, setCidadeTomador] = useState('');
    const [bairroTomador, setBairroTomador] = useState('');
    const [valorServico, setValorServico] = useState('');
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [mensagem, setMensagem] = useState('');


    const [tipoTributacao, setTipoTributacao] = useState(6);
    const [exigibilidade, setExigibilidade] = useState(1);
    const [aliquota, setAliquota] = useState('');

    const [open, setOpen] = useState(false);

    const [showConfigAvancadaNfse, setShowConfigAvancadaNfse] = useState(false);
    const [dataCompetencia, setDataCompetencia] = useState(new Date());
    const [deducoes, setDeducoes] = useState('0');
    const [baseCalculo, setBaseCalculo] = useState('0');
    const [valorLiquido, setValorLiquido] = useState('0');
    const [notaLoading, setNotaLoading] = useState(false);
    const [alqSimplesNacional, setAlqSimplesNacional] = useState('0');
    const [limiteNotas, setLimiteNotas] = useState(0);
    const [qtdEmitidas, setQtdEmitidas] = useState(0);
    const [descricaoDoServico, setDescricaoDoServico] = useState('');
    const [cnpjEmpresa, setCnpjEmpresa] = useState('');
    const [razaoSocialEmpresa, setRazaoSocialEmpresa] = useState('');
    const [paisTomador, setPaisTomador] = useState('Brasil');
    const [telefoneTomador, setTelefoneTomador] = useState('');
    const [nomeTomador, setNomeTomador] = useState('');
    const [codigo, setCodigo] = useState('');
    const [codigoIbgeTomador, setCodigoIbgeTomador] = useState('');
    const [reterIr, setReterIr] = useState(false);
    const [valorIrRetido, setValorIrRetido] = useState('');


    useEffect(() => {
        if (servicos.length === 0) {
            fetchUser();
        }
        setServicos(user?.servicos || []);
        setCnpjEmpresa(user?.empresa?.cnpj || '');
        setRazaoSocialEmpresa(user?.empresa?.razaoSocial || '');
    }, [user]);

    const handleCnpjTomador = async (e) => {
        let value = e.target.value;
        if (!value) return;

        const somenteNumeros = value.replace(/\D/g, "");

        // CPF até 11 dígitos | CNPJ até 14 dígitos
        if (somenteNumeros.length <= 11) {
            setCpfCnpjTomador(MascaraCpf(value));
            return;
        }

        // Caso seja CNPJ
        setCpfCnpjTomador(MascaraCnpj(value));
    };

    const handleCepTomador = async (e) => {
        let value = TirarMascara(e.target.value.slice(0, 9));
        setCepTomador(value);
        console.log("CEP do tomador alterado para:", value);
        if (value.length === 8) {
            console.log("Buscando endereço para CEP:", value);
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
                console.log("Endereço encontrado:", response.data);
                setEnderecoTomador(response.data.logradouro || '');
                setCidadeTomador(response.data.localidade || '');
                setEstadoTomador(response.data.uf.toLowerCase() || '');
                setBairroTomador(response.data.bairro || '');
                setCodigoIbgeTomador(response.data.ibge || '');
                setPaisTomador('Brasil'); // Definindo o país como Brasil
            } catch (error) {
                setEnderecoTomador('');
                setCidadeTomador('');
                setEstadoTomador('');
                setBairroTomador('');
                setCodigoIbgeTomador('');
                setPaisTomador('');
                alert("Erro ao buscar endereço para o CEP informado. Verifique se o CEP é válido.");
                console.error("Erro ao buscar endereço:", error);
            }
        }
    }

    const handleShowInformation = () => {
        setShowConfigAvancadaNfse(!showConfigAvancadaNfse)

        setReterIr(false);
        setValorIrRetido('');

    }


    const handleDeducoesChange = (e) => {
        const value = e.target.value;

        const parseCurrency = (valor) => {
            if (!valor) return 0;

            return Number(
                valor
                    .replace("R$ ", "")
                    .replace(/\./g, "")
                    .replace(",", ".")
            );
        };

        const valorServicoNumber = parseCurrency(valorServico);
        let deducoesNumber = parseCurrency(value);

        // Não permite dedução maior que o valor do serviço
        if (deducoesNumber > valorServicoNumber) {
            alert("Deduções não podem ser maiores que o valor do serviço.");
            deducoesNumber = 0;
        }

        const baseCalculoNumber = Math.max(
            valorServicoNumber - deducoesNumber,
            0
        );

        setDeducoes(
            deducoesNumber.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );

        setBaseCalculo(
            baseCalculoNumber.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );

        setValorLiquido(
            (valorServicoNumber).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );
    };


    const handleIrChange = (e) => {

        const moedaParaNumero = (valor = "") => {
            return Number(
                valor
                    .toString()
                    .replace("R$", "")
                    .replace(/\s/g, "")
                    .replace(/\./g, "")
                    .replace(",", ".")
            ) || 0;
        };

        setValorIrRetido(e.target.value);
        setValorLiquido((moedaParaNumero(baseCalculo) - moedaParaNumero(e.target.value)).toFixed(2).replace('.', ','));
    }

    const handleEmitirNota = async () => {

        const formatarValor = (valor) => {
            return Number(valor.replace("R$ ", "").replace(/\./g, "").replace(",", "."));
        };

        console.log(Number((Number(valorServico.replace(/\./g, '').replace(',', '.')) * 10).toFixed(2)));

        if (hasTomador) {
            if (!cpfCnpjTomador) {
                alert('Por favor, preencha todos os dados do tomador.');
                return;
            }
        }

        if (!codigo) {
            alert('Por favor, selecione um serviço.');
            return;
        }

        if (!descricaoDoServico) {
            alert('Por favor, informe a descrição do serviço.');
            return;
        }

        if (!valorServico || formatarValor(valorServico) <= 0) {
            alert('Por favor, informe um valor de serviço válido.');
            return;
        }

        const body = {
            idUsuario: Number(user.usuario.idUsuario),
            dataCompetencia: dataCompetencia.toISOString(),
            tomador: {
                name: hasTomador ? nomeTomador : null,
                federalTaxNumber: hasTomador ? TirarMascara(cpfCnpjTomador) : null,
                email: hasTomador ? emailTomador : null,
                phoneNumber: hasTomador ? TirarMascara(telefoneTomador) : null,
                address: {
                    street: hasTomador ? enderecoTomador : null,
                    district: hasTomador ? bairroTomador : null,
                    postalCode: hasTomador ? TirarMascara(cepTomador) : null,
                    number: hasTomador ? numeroTomador : null,
                    city: {
                        name: hasTomador ? cidadeTomador : null,
                        state: hasTomador ? estadoTomador : null,
                        code: hasTomador ? codigoIbgeTomador : null
                    },
                    country: hasTomador ? "BRA" : null
                }
            },
            total: {
                valorServico: formatarValor(valorServico),
                valorLiquido: formatarValor(valorLiquido),
                alqIss: 0,
                valorIss: 0,
                alqPis: 0,
                valorPis:  0,
                alqCofins:  0,
                valorCofins: 0,
                alqCsll: 0,
                valorCsll:  0,
                alqIr:  0,
                valorIr:  0,
                alqInss:  0,
                valorInss:  0,
                reterIss: false,
                valorIssRetido:  0,
                reterPis: false,
                valorPisRetido:  0,
                reterCofins: false,
                valorCofinsRetido:  0,
                reterCsll: false,
                valorCsllRetido: 0,
                reterIr,
                valorIrRetido: valorIrRetido ? formatarValor(valorIrRetido) : 0,
                reterInss: false,
                valorInssRetido: 0,
            },
            approximateTaxes: {
                simplesNacionalRate: alqSimplesNacional ? formatarValor(alqSimplesNacional) : 0,
                mode: "simplified"
            },
            descricaoDoServico,
            codigo,
            hasTomador
        };
        setNotaLoading(true);
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/emitirNotaServico`, body, {
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        });
        console.log(response.data);
        if (response.data.status === 200) {
            setNotaLoading(false);
            setMensagem('Nota fiscal emitida com sucesso!');
            setOpenSnackbarSuccess(true);
            setCodigo('');
            setDescricaoDoServico('');
            setValorServico('');
            setValorLiquido('');
            setBaseCalculo('');
            setReterIr(false);
            setValorIrRetido('');
            setAlqSimplesNacional('');
        } else {
            setNotaLoading(false);
            alert('Erro ao emitir nota fiscal: ' + response.data);
        }
    }


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <ReceiptIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Emitir Nota Fiscal de Serviço
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>

                    <Card style={{ width: window.innerWidth > 1200 ? "80%" : "100%", maxWidth: "1200px", borderRadius: "5px", backgroundColor: "#f7f7f7ff", margin: "0 auto" }}>
                        <div style={{ padding: "15px" }}>
                            <h2>Emitir Nota Fiscal (Serviço)</h2>
                        </div>
                        <Divider />
                        <div style={{ padding: "15px" }}>
                            <div style={{ marginTop: "20px" }}>
                                <h3>Prestador</h3>
                                <Divider />
                                <div style={{ marginTop: "10px" }}>
                                    <p style={{ fontSize: "14px" }}>Dados do prestador:</p>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                    <TextField size='small' label="CPF ou CNPJ" disabled required variant="outlined" value={MascaraCnpj(cnpjEmpresa)} style={{ width:  '49%' }} />
                                    <TextField size='small' label="Razão Social" disabled required variant="outlined" value={razaoSocialEmpresa} style={{ width: '49%' }} />
                                </div>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                <h3>Tomador</h3>
                                <Divider />
                                <FormControlLabel control={<Checkbox defaultChecked={hasTomador} onChange={(e) => setHasTomador(e.target.checked)} />} label="Nota possui tomador?" />
                                {hasTomador ? (
                                    <div style={{ marginTop: "10px" }}>
                                        <div style={{ marginBottom: "10px" }}>
                                            <p style={{ fontSize: "14px" }}>Preencha os dados do tomador:</p>
                                        </div>
                                        <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                            <TextField size='small' label="Nome" required variant="outlined" style={{ width: window.innerWidth > 1200 ? '49%' : '100%' }} value={nomeTomador} onChange={e => setNomeTomador(e.target.value)} />
                                            <TextField size='small' label="CPF ou CNPJ" required variant="outlined" style={{ width: window.innerWidth > 1200 ? '49%' : '100%' }} value={cpfCnpjTomador} onChange={e => handleCnpjTomador(e)} />
                                        </div>
                                        <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                            <TextField size='small' label="E-mail" variant="outlined" style={{ width: window.innerWidth > 1200 ? '49%' : '100%' }} value={emailTomador} onChange={e => setEmailTomador(e.target.value)} />
                                            <TextField size='small' label="Telefone" variant="outlined" style={{ width: window.innerWidth > 1200 ? '49%' : '100%' }} value={telefoneTomador} onChange={e => setTelefoneTomador(e.target.value)} />
                                        </div>
                                        <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                            <TextField size='small' label="CEP" variant="outlined" style={{ width: window.innerWidth > 1200 ? '30%' : '100%' }} value={MascaraCep(cepTomador)} onChange={e => handleCepTomador(e)} />
                                            <TextField disabled size='small' label="Endereço" variant="outlined" style={{ width: window.innerWidth > 1200 ? '59%' : '100%' }} value={enderecoTomador} onChange={e => setEnderecoTomador(e.target.value)} />
                                            <TextField size='small' label="Nª" variant="outlined" style={{ width: window.innerWidth > 1200 ? '8%' : '100%' }} value={numeroTomador} onChange={e => setNumeroTomador(e.target.value)} />
                                        </div>
                                        <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>

                                            <TextField disabled size='small' label="País" variant="outlined" style={{ width: window.innerWidth > 1200 ? '24%' : '100%' }} value={paisTomador} onChange={e => setPaisTomador(e.target.value)} />
                                            <TextField disabled size='small' label="Estado" variant="outlined" style={{ width: window.innerWidth > 1200 ? '24%' : '100%' }} value={estadoTomador} onChange={e => setEstadoTomador(e.target.value)} />
                                            <TextField disabled size='small' label="Cidade" variant="outlined" style={{ width: window.innerWidth > 1200 ? '24%' : '100%' }} value={cidadeTomador} onChange={e => setCidadeTomador(e.target.value)} />
                                            <TextField disabled size='small' label="Bairro" variant="outlined" style={{ width: window.innerWidth > 1200 ? '24%' : '100%' }} value={bairroTomador} onChange={e => setBairroTomador(e.target.value)} />
                                        </div>
                                    </div>
                                ) : (
                                    <p style={{ fontSize: "14px", color: "orange" }}>Nota fiscal de serviço sem tomador.</p>
                                )}
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                <h3>Serviço</h3>
                                <Divider />
                                <div style={{ marginTop: "10px" }}>
                                    <div style={{ marginTop: "30px", display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                        <FormControl size='small' fullWidth>
                                            <InputLabel id="demo-simple-select-label">Selecione o serviço</InputLabel>
                                            <Select
                                                value={codigo}
                                                label="Selecione o serviço"
                                                onChange={e => setCodigo(e.target.value)}
                                            >
                                                {servicos ? servicos.map(servico => (
                                                    <MenuItem key={servico.codigo} value={servico.codigo}>
                                                        {servico.codigo.replace(/\D/g, "").match(/.{1,2}/g)?.join(".") || ""} - {servico.discriminacao}
                                                    </MenuItem>
                                                )) : null}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between' }}>
                                        <TextField size='small' multiline rows={2} label="Descrição do Serviço" variant="outlined" style={{ width: '100%' }} value={descricaoDoServico} onChange={e => setDescricaoDoServico(e.target.value)} />
                                    </div>
                                    <div style={{ marginTop: "30px", display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                        <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size='small' label="Valor do Serviço" value={valorServico} onChange={e => { setValorServico(e.target.value); setBaseCalculo(e.target.value); setValorLiquido(e.target.value); }} variant="outlined" style={{ width: window.innerWidth > 1200 ? '49%' : '100%' }} />
                                        <TextField size='small' label="Alíquota Simples Nacional / Mês" variant="outlined" style={{ width: window.innerWidth > 1200 ? '49%' : '100%' }} value={alqSimplesNacional} onChange={e => {
                                            // permitir apenas numeros e virgula
                                            const value = e.target.value.replace(/[^0-9,]/g, '').trim();
                                            setAlqSimplesNacional(value);
                                        }} />

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "15px" }}>
                            <Box
                                onClick={() => handleShowInformation()}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    cursor: "pointer",
                                    color: "primary.main",
                                    fontWeight: 600,
                                    userSelect: "none",
                                    width: "fit-content",
                                    transition: "0.2s",
                                    "&:hover": {
                                        color: "primary.dark",
                                    },
                                }}
                            >
                                {showConfigAvancadaNfse ? <ExpandLess /> : <ExpandMore />}

                                <Typography variant="body2" fontWeight={600}>
                                    {showConfigAvancadaNfse
                                        ? "Ocultar configurações avançadas"
                                        : "Exibir configurações avançadas"}
                                </Typography>
                            </Box>
                            <div style={{ justifyContent: 'space-between', flexDirection: 'column', gap: '16px', marginTop: '16px', display: showConfigAvancadaNfse ? 'flex' : 'none', transition: 'all 0.3s ease-in-out' }}>
                                <Box sx={{ mt: 3, p: 3, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, }} >
                                        Informações da Nota
                                    </Typography>

                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, }}  >
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}
                                            adapterLocale={ptBR}
                                        >
                                            <DatePicker
                                                label="Data de Competência"
                                                value={dataCompetencia}
                                                onChange={(newValue) => setDataCompetencia(newValue)}
                                                format="dd/MM/yyyy"
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        sx: {
                                                            flex: "1 1 220px",
                                                        },
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                        <NumericFormat disabled customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size="small" label="Deduções (R$)" sx={{ flex: "1 1 180px", }} value={deducoes} onChange={(e) => handleDeducoesChange(e)} />
                                        <TextField disabled size="small" label="Base de Cálculo (R$)" sx={{ flex: "1 1 180px", }} value={baseCalculo} />
                                        <TextField disabled size="small" label="Valor Líquido (R$)" sx={{ flex: "1 1 180px", }} value={valorLiquido} />
                                    </Box>

                                    <Divider sx={{ my: 3 }} />

                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        label="Informações Complementares"
                                        placeholder="Digite observações que deverão constar na NFS-e..."
                                    />
                                </Box>
                                {/* <h4>Impostos</h4>
                                        <Divider /> */}
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, }} >
                                    {/* ISS */}
                                    {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    ISS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoIssAlq(e.target.value); setImpostoIssValor(handleCalcularImposto(e.target.value)); }} value={impostoIssAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoIssValor} />
                                                </Box>
                                            </Box> */}

                                    {/* PIS */}
                                    {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    PIS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoPisAlq(e.target.value); setImpostoPisValor(handleCalcularImposto(e.target.value)); }} value={impostoPisAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoPisValor} />
                                                </Box>
                                            </Box> */}

                                    {/* COFINS */}
                                    {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    COFINS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoCofinsAlq(e.target.value); setImpostoCofinsValor(handleCalcularImposto(e.target.value)); }} value={impostoCofinsAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoCofinsValor} />
                                                </Box>
                                            </Box> */}

                                    {/* CSLL */}
                                    {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    CSLL
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoCsllAlq(e.target.value); setImpostoCsllValor(handleCalcularImposto(e.target.value)); }} value={impostoCsllAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoCsllValor} />
                                                </Box>
                                            </Box> */}

                                    {/* IR */}
                                    {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    IR
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoIrAlq(e.target.value); setImpostoIrValor(handleCalcularImposto(e.target.value)); }} value={impostoIrAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoIrValor} />
                                                </Box>
                                            </Box> */}

                                    {/* INSS */}
                                    {/* <Box sx={{ flex: "1 1 260px", minWidth: 250, p: 2, border: "1px solid #E5E7EB", borderRadius: 2, bgcolor: "#FAFAFA", }} >
                                                <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }} >
                                                    INSS
                                                </Typography>

                                                <Box sx={{ display: "flex", gap: 1.5 }}>
                                                    <TextField size="small" label="Alíquota (%)" fullWidth onChange={(e) => { setImpostoInssAlq(e.target.value); setImpostoInssValor(handleCalcularImposto(e.target.value)); }} value={impostoInssAlq} />
                                                    <TextField size="small" label="Valor" disabled fullWidth value={impostoInssValor} />
                                                </Box>
                                            </Box> */}
                                </Box>
                                <h4>Retenções</h4>
                                <Divider />
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, }} >
                                    {/* ISS */}
                                    {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter ISS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterIss(e.target.checked); setValorIssRetido(''); }} checked={reterIss} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorIssRetido} onChange={e => setValorIssRetido(e.target.value)} disabled={!reterIss} />
                                                </FormControl>
                                            </Box> */}

                                    {/* PIS */}
                                    {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter PIS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterPis(e.target.checked); setValorPisRetido(''); }} checked={reterPis} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorPisRetido} onChange={e => setValorPisRetido(e.target.value)} disabled={!reterPis} />
                                                </FormControl>
                                            </Box> */}

                                    {/* COFINS */}
                                    {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter COFINS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterCofins(e.target.checked); setValorCofinsRetido(''); }} checked={reterCofins} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorCofinsRetido} onChange={e => setValorCofinsRetido(e.target.value)} disabled={!reterCofins} />
                                                </FormControl>
                                            </Box> */}

                                    {/* CSLL */}
                                    {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter CSLL
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterCsll(e.target.checked); setValorCsllRetido(''); }} checked={reterCsll} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorCsllRetido} onChange={e => setValorCsllRetido(e.target.value)} disabled={!reterCsll} />
                                                </FormControl>
                                            </Box> */}

                                    {/* IR */}
                                    <Box sx={{ flex: "1 1 230px", maxWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                        <FormControl fullWidth>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                <FormLabel sx={{ fontWeight: 600 }}>
                                                    Reter IR
                                                </FormLabel>
                                                <Switch color="primary" onChange={(e) => { setReterIr(e.target.checked); setValorIrRetido(''); }} checked={reterIr} />
                                            </Box>
                                            <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorIrRetido} onChange={e => handleIrChange(e)} disabled={!reterIr} />
                                        </FormControl>
                                    </Box>

                                    {/* INSS */}
                                    {/* <Box sx={{ flex: "1 1 230px", minWidth: 220, border: "1px solid #E5E7EB", borderRadius: 2, p: 2, bgcolor: "#FAFAFA", transition: "0.2s", "&:hover": { boxShadow: 2, }, }} >
                                                <FormControl fullWidth>
                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }} >
                                                        <FormLabel sx={{ fontWeight: 600 }}>
                                                            Reter INSS
                                                        </FormLabel>
                                                        <Switch color="primary" onChange={(e) => { setReterInss(e.target.checked); setValorInssRetido(''); }} checked={reterInss} />
                                                    </Box>
                                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorInssRetido} onChange={e => setValorInssRetido(e.target.value)} disabled={!reterInss} />
                                                </FormControl>
                                            </Box> */}
                                </Box>
                            </div>
                        </div>
                        <div style={{ padding: "15px", backgroundColor: "#ffffffff", borderRadius: "0 0 5px 5px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                            <Button variant="contained" size="small" sx={{ backgroundColor: "#0b243d" }} loading={notaLoading} onClick={handleEmitirNota}>Emitir Nota Fiscal</Button>
                        </div>
                    </Card >
                </div>
            </div>
            <Loading open={open} setOpen={setOpen} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
        </>
    )
}


export default EmitirNotaServico;